import { render, staticRenderFns } from "./salesFreightBillDetails.vue?vue&type=template&id=1cd46c15&scoped=true&"
import script from "./salesFreightBillDetails.vue?vue&type=script&lang=js&"
export * from "./salesFreightBillDetails.vue?vue&type=script&lang=js&"
import style0 from "./salesFreightBillDetails.vue?vue&type=style&index=0&id=1cd46c15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd46c15",
  null
  
)

export default component.exports